import { useGoogleAnalytics } from '~/pages/layout/hooks/useGoogleAnalytics';
import { useGoogleAnalyticsUserProperties } from '~/pages/layout/hooks/useGoogleAnalyticsUserProperties';

/**
 * Runs GA init and user-property sync in one component so effects run in
 * declaration order (init before set user_properties). Must sit under
 * AuthProvider + QueryClientProvider.
 *
 * GA4 Admin: register a user-scoped custom dimension for `user_group` so it
 * appears in reports / DebugView.
 */
export function GoogleAnalyticsSync({ enabled }: { enabled: boolean }) {
  useGoogleAnalytics({ enabled });
  useGoogleAnalyticsUserProperties({ enabled });
  return null;
}
